import { createRoot } from "react-dom/client";
import React from "react";
import App from "./App";
import theme from "./theme";
import { ChakraProvider } from "@chakra-ui/react";

const root = createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);